import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import _Button2 from "@mui/material/Button";
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
function getRemaining(startDate) {
  const diff = moment.duration(startDate.diff(moment()));
  return {
    days: Math.max(0, Math.floor(diff.asDays())),
    hours: Math.max(0, diff.hours()),
    minutes: Math.max(0, diff.minutes())
  };
}
function CountdownCard({
  Button: _Button,
  highlightRegisterCta,
  isMember,
  onRegisterClick,
  startDate
}) {
  const {
    t
  } = useTranslation();
  const Button = _Button || _Button2;
  const [remaining, setRemaining] = useState(() => getRemaining(startDate));
  useEffect(() => {
    const interval = setInterval(() => setRemaining(getRemaining(startDate)), 60000);
    return () => clearInterval(interval);
  }, [startDate]);
  return /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    padding: 3,
    sx: {
      background: 'linear-gradient(90deg, #FFF5D0 0%, #ECFBF4 100%)',
      border: '1px solid #C9E9F8',
      borderRadius: '16px'
    }
  }, /*#__PURE__*/React.createElement(_Typography, {
    sx: {
      fontSize: 16,
      fontWeight: 700,
      lineHeight: 1.6
    }
  }, t('commons.challenges.countdown.title')), /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 2,
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flex: 1,
    gap: 2
  }, /*#__PURE__*/React.createElement(CountUnit, {
    label: t('commons.challenges.countdown.days'),
    value: remaining.days
  }), /*#__PURE__*/React.createElement(CountUnit, {
    label: t('commons.challenges.countdown.hours'),
    value: remaining.hours
  }), /*#__PURE__*/React.createElement(CountUnit, {
    label: t('commons.challenges.countdown.minutes'),
    value: remaining.minutes
  })), !isMember && onRegisterClick && /*#__PURE__*/React.createElement(Button, {
    disableElevation: true,
    onClick: onRegisterClick,
    size: "small",
    sx: {
      bgcolor: highlightRegisterCta ? '#6236BD' : '#326AC2',
      color: '#fff',
      flexShrink: 0,
      '&:hover': {
        bgcolor: highlightRegisterCta ? '#4d2b96' : '#2558a8'
      }
    },
    variant: "contained"
  }, t('commons.challenges.register_company_cta'))));
}
function CountUnit({
  value,
  label
}) {
  return /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    bgcolor: "#fff",
    borderRadius: 3,
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: 0.5,
    padding: 2
  }, /*#__PURE__*/React.createElement(_Typography, {
    sx: {
      fontSize: 32,
      fontWeight: 800,
      lineHeight: 1
    }
  }, String(value).padStart(2, '0')), /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    variant: "caption"
  }, label));
}
export default CountdownCard;